import PdfLargeSVG from '../Icons/PdfLargeSVG.svg';
import CvIconContainer from './CvIconContainer';
import UIStrings from '@/Utils/UIStrings';

function PdfLargeIcon() {
    return (
        <CvIconContainer>
            <object
                className="h-full"
                type="image/svg+xml"
                data={PdfLargeSVG}
                aria-label={UIStrings.Pdf}
                data-cy="PdfLargeIcon"
            />
        </CvIconContainer>
    );
}
export default PdfLargeIcon;
